import { takeLatest, call, put, all } from "redux-saga/effects";

import {
  fetchFundInfo,
  fetchHistoricalNav,
  fetchHistoricalNavGraph,
  fetchDividend,
  fetchDividendGroupByYear,
  fetchDrawdownByDate,
  fetchMaximumDrawdown,
  fetchMonthlyReturn,
  fetchPriceRange,
  fetchVolatilities,
  fetchReturnExpenseRatio,
  fetchMonthlyProfit,
  fetchReturnHistory,
  fetchTradingInformation,
  fetchFundAverageRating,
  voteFundAverageRating,
  fetchPortByFundId,
  fetchPortChartByFundIdAndChartType,
  fetchWeeklyFundRanking,
  fetchPortfolioInformation,
  fetchDividendDescription,
} from "../_services/information.services";
import { fetchCalendarByDate } from "../_services/calendar.services";

import { informationConstants } from "../_constants/information.constants";

import {
  fetchFundInfoSuccess,
  fetchFundInfoFailure,
  clearFundInfo,
  fetchTradingInformationSuccess,
  fetchTradingInformationFailure,
  fetchFundAverageRatingSuccess,
  fetchFundAverageRatingFailure,
  fetchCalendarFundSuccess,
  fetchCalendarFundFailure,
  fetchHistoricalNavSuccess,
  fetchHistoricalNavFailure,
  fetchHistoricalNavGraphSuccess,
  fetchHistoricalNavGraphFailure,
  fetchFundAverageRatingStart,
  fetchFundPortInfoSuccess,
  fetchFundPortInfoFailure,
  fetchFundPortChartByChartTypeSuccess,
  fetchFundPortChartByChartTypeFailure,
  fetchDividendSuccess,
  fetchDividendFailure,
  fetchDividendGroupByYearSuccess,
  fetchDividendGroupByYearFailure,
  fetchWeeklyFundRankingSuccess,
  fetchWeeklyFundRankingFailure,
  fetchDrawdownByDateSuccess,
  fetchDrawdownByDateFailure,
  fetchMaximumDrawdownSuccess,
  fetchMaximumDrawdownFailure,
  fetchDrawdownNavGraphSuccess,
  fetchDrawdownNavGraphFailure,
  fetchMonthlyReturnSuccess,
  fetchMonthlyReturnFailure,
  fetchPriceRangeSuccess,
  fetchPriceRangeFailure,
  fetchVolatilitiesSuccess,
  fetchVolatilitiesFailure,
  fetchReturnExpenseRatioSuccess,
  fetchReturnExpenseRatioFailure,
  fetchMonthlyProfitSuccess,
  fetchMonthlyProfitFailure,
  fetchReturnHistorySuccess,
  fetchReturnHistoryFailure,
  fetchPortfolioInformationSuccess,
  fetchPortfolioInformationFailure,
  fetchDividendDescriptionSuccess,
  fetchDividendDescriptionFailure,
} from "../_actions/information.actions";

import { convertDataToPortChart } from "../_utils/information.utils";

export function* fetchFundInfoAsync({ payload }) {
  try {
    yield put(clearFundInfo());
    const result = yield call(fetchFundInfo, payload);
    yield put(fetchFundInfoSuccess(result.data));
  } catch (error) {
    yield put(fetchFundInfoFailure(error.message));
  }
}

export function* fetchPortfolioInformationAsync({ payload }) {
  try {
    const result = yield call(fetchPortfolioInformation, payload);
    yield put(fetchPortfolioInformationSuccess(result.data));
  } catch (error) {
    yield put(fetchPortfolioInformationFailure(error.message));
  }
}

export function* fetchTradingInformationAsync({ payload }) {
  try {
    const result = yield call(fetchTradingInformation, payload);
    yield put(fetchTradingInformationSuccess(result.data));
  } catch (error) {
    yield put(fetchTradingInformationFailure(error.message));
  }
}

export function* fetchHistoricalNavAsync({ payload }) {
  try {
    const result = yield call(fetchHistoricalNav, payload);
    yield put(fetchHistoricalNavSuccess(result.data));
  } catch (error) {
    yield put(fetchHistoricalNavFailure(error.message));
  }
}

export function* fetchFundAverageRatingAsync({ payload }) {
  try {
    const result = yield call(fetchFundAverageRating, payload);
    yield put(fetchFundAverageRatingSuccess(result.data));
  } catch (error) {
    yield put(fetchFundAverageRatingFailure(error.message));
  }
}

export function* voteFundAverageRatingAsync({ payload }) {
  try {
    yield call(voteFundAverageRating, payload);
    yield put(fetchFundAverageRatingStart(payload.fundId));
  } catch (error) {}
}

export function* fetchPortByFundIdAsync({ payload }) {
  try {
    const result = yield call(fetchPortByFundId, payload);
    yield put(fetchFundPortInfoSuccess(result.data));
  } catch (error) {
    yield put(fetchFundPortInfoFailure(error));
  }
}

export function* fetchPortChartByChartTypeAsync({ payload }) {
  try {
    const result = yield call(fetchPortChartByFundIdAndChartType, payload);
    const convertData = convertDataToPortChart(result.data, payload.chartType);
    yield put(fetchFundPortChartByChartTypeSuccess(convertData));
  } catch (error) {
    yield put(fetchFundPortChartByChartTypeFailure(error));
  }
}

export function* fetchCalendarFundStartAsync({ payload }) {
  try {
    const result = yield call(fetchCalendarByDate, payload);
    yield put(fetchCalendarFundSuccess(result.data));
  } catch (error) {
    yield put(fetchCalendarFundFailure(error));
  }
}

export function* fetchHistoricalNavGraphAsync({ payload }) {
  try {
    const result = yield call(fetchHistoricalNavGraph, payload);
    yield put(fetchHistoricalNavGraphSuccess(result.data));
  } catch (error) {
    yield put(fetchHistoricalNavGraphFailure(error.message));
  }
}

export function* fetchWeeklyFundRankingAsync({ payload }) {
  try {
    const result = yield call(fetchWeeklyFundRanking, payload);
    yield put(fetchWeeklyFundRankingSuccess(result.data));
  } catch (error) {
    yield put(fetchWeeklyFundRankingFailure(error.message));
  }
}

export function* fetchDrawdownByDateAsync({ payload }) {
  try {
    const result = yield call(fetchDrawdownByDate, payload);
    yield put(fetchDrawdownByDateSuccess(result.data));
  } catch (error) {
    yield put(fetchDrawdownByDateFailure(error.message));
  }
}

export function* fetchMaximumDrawdownAsync({ payload }) {
  try {
    const result = yield call(fetchMaximumDrawdown, payload);
    yield put(fetchMaximumDrawdownSuccess(result.data));
  } catch (error) {
    yield put(fetchMaximumDrawdownFailure(error.message));
  }
}

export function* fetchDrawdownNavGraphAsync({ payload }) {
  try {
    const result = yield call(fetchHistoricalNavGraph, payload);
    yield put(fetchDrawdownNavGraphSuccess(result.data));
  } catch (error) {
    yield put(fetchDrawdownNavGraphFailure(error.message));
  }
}

export function* fetchMonthlyReturnAsync({ payload }) {
  try {
    const result = yield call(fetchMonthlyReturn, payload);
    yield put(fetchMonthlyReturnSuccess(result.data));
  } catch (error) {
    yield put(fetchMonthlyReturnFailure(error.message));
  }
}

export function* fetchVolatilitiesAsync({ payload }) {
  try {
    const result = yield call(fetchVolatilities, payload);
    yield put(fetchVolatilitiesSuccess(result.data));
  } catch (error) {
    yield put(fetchVolatilitiesFailure(error.message));
  }
}

export function* fetchPriceRangeAsync({ payload }) {
  try {
    const result = yield call(fetchPriceRange, payload);
    yield put(fetchPriceRangeSuccess(result.data));
  } catch (error) {
    yield put(fetchPriceRangeFailure(error.message));
  }
}

export function* fetchReturnExpenseRatioAsync({ payload }) {
  try {
    const result = yield call(fetchReturnExpenseRatio, payload);
    yield put(fetchReturnExpenseRatioSuccess(result.data));
  } catch (error) {
    yield put(fetchReturnExpenseRatioFailure(error.message));
  }
}

export function* fetchMonthlyProfitAsync({ payload }) {
  try {
    const result = yield call(fetchMonthlyProfit, payload);
    yield put(fetchMonthlyProfitSuccess(result.data));
  } catch (error) {
    yield put(fetchMonthlyProfitFailure(error.message));
  }
}

export function* fetchReturnHistoryAsync({ payload }) {
  try {
    const result = yield call(fetchReturnHistory, payload);
    yield put(fetchReturnHistorySuccess(result.data));
  } catch (error) {
    yield put(fetchReturnHistoryFailure(error.message));
  }
}

// Dividend
export function* fetchDividendAsync({ payload }) {
  try {
    const result = yield call(fetchDividend, payload);
    yield put(fetchDividendSuccess(result.data));
  } catch (error) {
    yield put(fetchDividendFailure(error.message));
  }
}

export function* fetchDividendGroupByYearAsync({ payload }) {
  try {
    const result = yield call(fetchDividendGroupByYear, payload);
    yield put(fetchDividendGroupByYearSuccess(result.data));
  } catch (error) {
    yield put(fetchDividendGroupByYearFailure(error.message));
  }
}

export function* fetchDividendDescriptionAsync({ payload }) {
  try {
    const result = yield call(fetchDividendDescription, payload);
    yield put(fetchDividendDescriptionSuccess(result.data));
  } catch (error) {
    yield put(fetchDividendDescriptionFailure(error.message));
  }
}

export function* fetchFundInfoStart() {
  yield takeLatest(
    informationConstants.FETCH_FUND_INFO_START,
    fetchFundInfoAsync
  );
}

export function* fetchPortfolioInformationStart() {
  yield takeLatest(
    informationConstants.FETCH_PORTFOLIO_INFO_START,
    fetchPortfolioInformationAsync
  );
}
export function* fetchTradingInformationStart() {
  yield takeLatest(
    informationConstants.FETCH_TRADING_INFO_START,
    fetchTradingInformationAsync
  );
}

export function* fetchHistoricalNavStart() {
  yield takeLatest(
    informationConstants.FETCH_HISTORICAL_NAV_START,
    fetchHistoricalNavAsync
  );
}

export function* fetchFundAverageRatingStartSaga() {
  yield takeLatest(
    informationConstants.FETCH_FUND_AVERAGE_RATING_START,
    fetchFundAverageRatingAsync
  );
}

export function* voteFundAverageRatingStart() {
  yield takeLatest(
    informationConstants.VOTE_FUND_AVERAGE_RATING,
    voteFundAverageRatingAsync
  );
}

export function* fetchPortByFundIdStart() {
  yield takeLatest(
    informationConstants.FETCH_FUND_PORT_INFO_START,
    fetchPortByFundIdAsync
  );
}

export function* fetchPortChartByChartTypeStart() {
  yield takeLatest(
    informationConstants.FETCH_FUND_PORT_CHART_BY_CHART_TYPE_START,
    fetchPortChartByChartTypeAsync
  );
}

export function* fetchCalendarFundStart() {
  yield takeLatest(
    informationConstants.FETCH_CALENDAR_FUND_START,
    fetchCalendarFundStartAsync
  );
}

export function* fetchHistoricalNavGraphStart() {
  yield takeLatest(
    informationConstants.FETCH_HISTORICAL_NAV_GRAPH_START,
    fetchHistoricalNavGraphAsync
  );
}

export function* fetchWeeklyFundRankingStart() {
  yield takeLatest(
    informationConstants.FETCH_WEEKLY_FUND_RANKING_START,
    fetchWeeklyFundRankingAsync
  );
}

export function* fetchDividendStart() {
  yield takeLatest(
    informationConstants.FETCH_DIVIDEND_START,
    fetchDividendAsync
  );
}

export function* fetchDividendDescriptionStart() {
  yield takeLatest(
    informationConstants.FETCH_DIVIDEND_DESCRIPTION_START,
    fetchDividendDescriptionAsync
  );
}

export function* fetchDrawdownByDateStart() {
  yield takeLatest(
    informationConstants.FETCH_DRAWDOWN_BY_DATE_START,
    fetchDrawdownByDateAsync
  );
}

export function* fetchMaximumDrawdownStart() {
  yield takeLatest(
    informationConstants.FETCH_MAXIMUM_DRAWDOWN_START,
    fetchMaximumDrawdownAsync
  );
}

export function* fetchDrawdownNavGraphStart() {
  yield takeLatest(
    informationConstants.FETCH_DRAWDOWN_NAV_GRAPH_START,
    fetchDrawdownNavGraphAsync
  );
}

export function* fetchMonthlyReturnStart() {
  yield takeLatest(
    informationConstants.FETCH_MONTHLY_RETURN_START,
    fetchMonthlyReturnAsync
  );
}

export function* fetchPriceRangeStart() {
  yield takeLatest(
    informationConstants.FETCH_PRICE_RANGE_START,
    fetchPriceRangeAsync
  );
}

export function* fetchVolatilitiesStart() {
  yield takeLatest(
    informationConstants.FETCH_VOLATILITIES_START,
    fetchVolatilitiesAsync
  );
}

export function* fetchReturnExpenseRatioStart() {
  yield takeLatest(
    informationConstants.FETCH_RETURN_EXPENSE_RATIO_START,
    fetchReturnExpenseRatioAsync
  );
}

export function* fetchMonthlyProfitStart() {
  yield takeLatest(
    informationConstants.FETCH_MONTHLY_PROFIT_START,
    fetchMonthlyProfitAsync
  );
}

export function* fetchReturnHistoryStart() {
  yield takeLatest(
    informationConstants.FETCH_RETURN_HISTORY_START,
    fetchReturnHistoryAsync
  );
}

export function* fetchDividendGroupByYearStart() {
  yield takeLatest(
    informationConstants.FETCH_DIVIDEND_GROUP_BY_YEAR_START,
    fetchDividendGroupByYearAsync
  );
}

export function* informationSagas() {
  yield all([
    call(fetchFundInfoStart),
    call(fetchPortfolioInformationStart),
    call(fetchTradingInformationStart),
    call(fetchFundAverageRatingStartSaga),
    call(voteFundAverageRatingStart),
    call(fetchCalendarFundStart),
    call(fetchPortByFundIdStart),
    call(fetchPortChartByChartTypeStart),
    call(fetchHistoricalNavStart),
    call(fetchHistoricalNavGraphStart),
    call(fetchDividendStart),
    call(fetchWeeklyFundRankingStart),
    call(fetchDrawdownByDateStart),
    call(fetchMaximumDrawdownStart),
    call(fetchDrawdownNavGraphStart),
    call(fetchMonthlyReturnStart),
    call(fetchPriceRangeStart),
    call(fetchVolatilitiesStart),
    call(fetchReturnExpenseRatioStart),
    call(fetchMonthlyProfitStart),
    call(fetchReturnHistoryStart),
    call(fetchDividendGroupByYearStart),
    call(fetchDividendDescriptionStart),
  ]);
}
